var map = {
	"./ask-and-liv.png": 21131,
	"./background-audio.svg": 1571,
	"./background-autumn.jpg": 38275,
	"./background-forest.jpg": 74797,
	"./background-menu.png": 56325,
	"./background-popup.png": 58357,
	"./background-tracks.svg": 40591,
	"./backgrounds-story/animation/chapter-1/background.png": 33439,
	"./backgrounds-story/animation/chapter-1/deer-ear.png": 52331,
	"./backgrounds-story/animation/chapter-1/deer.png": 29690,
	"./backgrounds-story/animation/chapter-1/fog.png": 481,
	"./backgrounds-story/animation/chapter-1/foreground.png": 87082,
	"./backgrounds-story/animation/chapter-10/background.png": 20204,
	"./backgrounds-story/animation/chapter-10/water-01.png": 2466,
	"./backgrounds-story/animation/chapter-10/water-02.png": 43489,
	"./backgrounds-story/animation/chapter-10/water-03.png": 36869,
	"./backgrounds-story/animation/chapter-2/background.png": 66858,
	"./backgrounds-story/animation/chapter-2/foreground.png": 58822,
	"./backgrounds-story/animation/chapter-2/hare-01.png": 51383,
	"./backgrounds-story/animation/chapter-2/hare-02.png": 90407,
	"./backgrounds-story/animation/chapter-2/hare-03.png": 9051,
	"./backgrounds-story/animation/chapter-3/background.png": 84864,
	"./backgrounds-story/animation/chapter-3/foreground.png": 80455,
	"./backgrounds-story/animation/chapter-3/tjur-01.png": 9352,
	"./backgrounds-story/animation/chapter-3/tjur-02.png": 38438,
	"./backgrounds-story/animation/chapter-3/tjur-03.png": 45826,
	"./backgrounds-story/animation/chapter-4/background.png": 14395,
	"./backgrounds-story/animation/chapter-4/water-01.png": 7104,
	"./backgrounds-story/animation/chapter-4/water-02.png": 51928,
	"./backgrounds-story/animation/chapter-4/water-03.png": 66689,
	"./backgrounds-story/animation/chapter-4/water-04.png": 29677,
	"./backgrounds-story/animation/chapter-4/water-05.png": 15835,
	"./backgrounds-story/animation/chapter-5/background.png": 70295,
	"./backgrounds-story/animation/chapter-5/squirrel-01.png": 85131,
	"./backgrounds-story/animation/chapter-5/squirrel-02.png": 7493,
	"./backgrounds-story/animation/chapter-5/squirrel-03.png": 15795,
	"./backgrounds-story/animation/chapter-5/squirrel-04.png": 17946,
	"./backgrounds-story/animation/chapter-6/background.png": 85786,
	"./backgrounds-story/animation/chapter-6/birds-01.png": 26423,
	"./backgrounds-story/animation/chapter-6/fog.png": 15000,
	"./backgrounds-story/animation/chapter-6/foreground.png": 11670,
	"./backgrounds-story/animation/chapter-6/water-01.png": 4154,
	"./backgrounds-story/animation/chapter-6/water-02.png": 69134,
	"./backgrounds-story/animation/chapter-6/water-03.png": 63328,
	"./backgrounds-story/animation/chapter-6/water-04.png": 89399,
	"./backgrounds-story/animation/chapter-6/water-05.png": 81111,
	"./backgrounds-story/animation/chapter-6/water-06.png": 50886,
	"./backgrounds-story/animation/chapter-7/background.png": 49229,
	"./backgrounds-story/animation/chapter-7/clouds.png": 20402,
	"./backgrounds-story/animation/chapter-7/foreground-01.png": 71835,
	"./backgrounds-story/animation/chapter-7/foreground-02.png": 46886,
	"./backgrounds-story/animation/chapter-7/grass-1.png": 3061,
	"./backgrounds-story/animation/chapter-7/grass-2.png": 53714,
	"./backgrounds-story/animation/chapter-7/grass-3.png": 79443,
	"./backgrounds-story/animation/chapter-7/water-01.png": 19486,
	"./backgrounds-story/animation/chapter-7/water-02.png": 82975,
	"./backgrounds-story/animation/chapter-8/background.png": 87074,
	"./backgrounds-story/animation/chapter-8/birds-01.png": 19444,
	"./backgrounds-story/animation/chapter-8/fog.png": 4573,
	"./backgrounds-story/animation/chapter-8/foreground.png": 95658,
	"./backgrounds-story/animation/chapter-8/glow.png": 92385,
	"./backgrounds-story/animation/chapter-9/background.png": 55089,
	"./backgrounds-story/animation/chapter-9/clouds.png": 4901,
	"./backgrounds-story/animation/chapter-9/foreground.png": 51863,
	"./backgrounds-story/animation/chapter-9/grass.png": 70012,
	"./backgrounds-story/animation/chapter-9/water-01.png": 92594,
	"./backgrounds-story/animation/chapter-9/water-02.png": 68856,
	"./backgrounds-story/animation/chapter-9/water-03.png": 83407,
	"./backgrounds-story/animation/chapter-9/water-04.png": 6134,
	"./backgrounds-story/animation/shared/dust1.png": 69453,
	"./backgrounds-story/animation/shared/dust2.png": 76592,
	"./backgrounds-story/animation/shared/sunbeams1-blur1.png": 91466,
	"./backgrounds-story/animation/shared/sunbeams1-blur2.png": 91778,
	"./backgrounds-story/animation/shared/sunbeams1-blur3.png": 89114,
	"./backgrounds-story/animation/shared/sunbeams1-blur4.png": 21212,
	"./backgrounds-story/animation/shared/sunbeams1-blur5.png": 71806,
	"./backgrounds-story/animation/shared/sunbeams1.png": 1440,
	"./backgrounds-story/animation/shared/sunbeams2-blur1.png": 85117,
	"./backgrounds-story/animation/shared/sunbeams2-blur2.png": 19605,
	"./backgrounds-story/animation/shared/sunbeams2-blur3.png": 34347,
	"./backgrounds-story/animation/shared/sunbeams2-blur4.png": 5068,
	"./backgrounds-story/animation/shared/sunbeams2-blur5.png": 12357,
	"./backgrounds-story/animation/shared/sunbeams2.png": 67044,
	"./backgrounds-story/chapter-1-thumb.png": 81033,
	"./backgrounds-story/chapter-10-thumb.png": 155,
	"./backgrounds-story/chapter-2-thumb.png": 50675,
	"./backgrounds-story/chapter-3-thumb.png": 35555,
	"./backgrounds-story/chapter-4-thumb.png": 43671,
	"./backgrounds-story/chapter-5-thumb.png": 69689,
	"./backgrounds-story/chapter-6-thumb.png": 34474,
	"./backgrounds-story/chapter-7-thumb.png": 24775,
	"./backgrounds-story/chapter-8-thumb.png": 7619,
	"./backgrounds-story/chapter-9-thumb.png": 60009,
	"./badges/fire-active.svg": 23649,
	"./badges/fire-inactive.svg": 92505,
	"./badges/fishing-active.svg": 58390,
	"./badges/fishing-inactive.svg": 49414,
	"./badges/hunt-active.svg": 56737,
	"./badges/hunt-inactive.svg": 4083,
	"./badges/music-active.svg": 67230,
	"./badges/music-inactive.svg": 7720,
	"./badges/rewards/background.png": 2795,
	"./badges/rewards/fire-glow.png": 61070,
	"./badges/rewards/fire.png": 57742,
	"./badges/rewards/fishing-glow.png": 64785,
	"./badges/rewards/fishing.png": 23489,
	"./badges/rewards/foreground.png": 33091,
	"./badges/rewards/hunt-glow.png": 35867,
	"./badges/rewards/hunt.png": 49370,
	"./badges/rewards/music-glow.png": 99538,
	"./badges/rewards/music.png": 67672,
	"./badges/rewards/stretcher-glow.png": 15633,
	"./badges/rewards/stretcher.png": 35491,
	"./badges/stretcher-active.svg": 56254,
	"./badges/stretcher-inactive.svg": 25371,
	"./box-selected.svg": 63234,
	"./box-story.svg": 73097,
	"./box.svg": 73332,
	"./chapter-nav-1-selected.svg": 49803,
	"./chapter-nav-1.svg": 38329,
	"./chapter-nav-2-selected.svg": 30132,
	"./chapter-nav-2.svg": 34093,
	"./chapter-nav-3-selected.svg": 76749,
	"./chapter-nav-3.svg": 35746,
	"./chapter-nav-4-selected.svg": 82410,
	"./chapter-nav-4.svg": 95988,
	"./chapter-nav-5-selected.svg": 87476,
	"./chapter-nav-5.svg": 64919,
	"./chapter-overview-1.svg": 73292,
	"./chapter-overview-2.svg": 44242,
	"./chapter-overview-3.svg": 34930,
	"./chapter-overview-4.svg": 77307,
	"./chapter-overview-5.svg": 51734,
	"./characters-ask-and-liv.png": 47238,
	"./cookie/cookies.svg": 63407,
	"./icon-arrow-back-red.svg": 67370,
	"./icon-arrow-back-white.svg": 89803,
	"./icon-arrow-down.svg": 23395,
	"./icon-arrow-up-new.svg": 42315,
	"./icon-arrow-up.svg": 51164,
	"./icon-book.svg": 81087,
	"./icon-book2.svg": 54527,
	"./icon-chapter-1.svg": 16013,
	"./icon-chapter-2.svg": 21789,
	"./icon-chapter-3.svg": 55361,
	"./icon-chapter-4.svg": 83389,
	"./icon-chapter-5.svg": 95876,
	"./icon-checkbox.svg": 55553,
	"./icon-checkmark-lightgreen.svg": 53951,
	"./icon-checkmark.svg": 71755,
	"./icon-circle.png": 56120,
	"./icon-close-green.svg": 4201,
	"./icon-close.svg": 21924,
	"./icon-download.svg": 66691,
	"./icon-info.svg": 94141,
	"./icon-loading.svg": 37213,
	"./icon-loading2.svg": 87448,
	"./icon-menu-bullet.svg": 10964,
	"./icon-next.svg": 87898,
	"./icon-pdf-white.svg": 62185,
	"./icon-pdf.svg": 40548,
	"./icon-prev.svg": 29417,
	"./icon-print.svg": 26703,
	"./icon-read-close.svg": 89158,
	"./icon-read-new.svg": 42058,
	"./icon-read-story.svg": 68789,
	"./icon-read-two.svg": 16339,
	"./icon-read.svg": 9905,
	"./icon-zoom.svg": 4280,
	"./illustrations/activity-01.png": 25282,
	"./illustrations/activity-02.png": 71141,
	"./illustrations/activity-03.png": 5063,
	"./illustrations/activity-04.png": 67262,
	"./illustrations/activity-05.png": 85274,
	"./illustrations/activity-06.png": 1225,
	"./illustrations/activity-07.png": 67360,
	"./illustrations/activity-08.png": 94257,
	"./illustrations/activity-09.png": 87491,
	"./illustrations/activity-10.png": 83258,
	"./illustrations/activity-11.png": 95392,
	"./illustrations/activity-12.png": 40656,
	"./illustrations/activity-13.png": 67757,
	"./illustrations/activity-14.png": 39714,
	"./illustrations/activity-15.png": 89754,
	"./illustrations/activity-16.png": 90105,
	"./illustrations/activity-17.png": 84655,
	"./illustrations/activity-18.png": 16960,
	"./illustrations/activity-19.png": 98608,
	"./illustrations/activity-20.png": 80399,
	"./illustrations/activity-21.png": 35319,
	"./illustrations/activity-22.png": 99061,
	"./illustrations/activity-23.png": 71344,
	"./illustrations/activity-24.png": 34327,
	"./illustrations/activity-25.png": 36666,
	"./illustrations/activity-26.png": 80189,
	"./illustrations/activity-27.png": 64809,
	"./illustrations/activity-28.png": 10994,
	"./illustrations/activity-29.png": 11476,
	"./illustrations/activity-30.png": 47760,
	"./illustrations/activity-31.png": 70001,
	"./illustrations/activity-32.png": 40941,
	"./illustrations/activity-33.png": 75584,
	"./illustrations/activity-34.png": 60864,
	"./illustrations/activity-35.png": 87274,
	"./illustrations/activity-36.png": 74903,
	"./illustrations/activity-37.png": 32674,
	"./illustrations/activity-38.png": 64328,
	"./illustrations/activity-39.png": 30040,
	"./illustrations/activity-40.png": 58399,
	"./illustrations/activity-41.png": 48237,
	"./illustrations/activity-42.png": 11130,
	"./illustrations/activity-43.png": 90150,
	"./illustrations/activity-44.png": 27265,
	"./illustrations/activity-45.png": 53667,
	"./illustrations/activity-46.png": 84488,
	"./illustrations/activity-47.png": 88996,
	"./illustrations/activity-48.png": 79813,
	"./illustrations/activity-49.png": 26614,
	"./illustrations/activity-50.png": 45618,
	"./illustrations/activity-51.png": 55397,
	"./illustrations/activity-52.png": 13707,
	"./illustrations/activity-53.png": 2090,
	"./illustrations/activity-54.png": 25812,
	"./illustrations/activity-55.png": 89833,
	"./illustrations/activity-56.png": 46350,
	"./illustrations/activity-57.png": 37417,
	"./illustrations/activity-58.png": 89452,
	"./illustrations/activity-59.png": 61614,
	"./illustrations/activity-60.png": 88138,
	"./illustrations/activity-61.png": 39685,
	"./illustrations/activity-62.png": 8699,
	"./illustrations/activity-63.png": 97778,
	"./illustrations/activity-64.png": 73581,
	"./illustrations/activity-65.png": 24896,
	"./illustrations/activity-66.png": 13514,
	"./illustrations/activity-67.png": 37953,
	"./illustrations/activity-68.png": 83226,
	"./illustrations/activity-69.png": 77536,
	"./illustrations/activity-70.png": 12319,
	"./illustrations/activity-71.png": 41792,
	"./illustrations/activity-72.png": 15990,
	"./illustrations/activity-73.png": 64168,
	"./logos/logo-blivnaturligvis-light.svg": 63090,
	"./logos/logo-blivnaturligvis.png": 29136,
	"./logos/logo-blivnaturligvis.svg": 22475,
	"./logos/logo-blivnaturligvisround.svg": 29354,
	"./logos/logo-cgl-dark.svg": 23379,
	"./logos/logo-cgl.svg": 11374,
	"./logos/logo-nordeafonden-dark.png": 71165,
	"./logos/logo-nordeafonden.png": 70031,
	"./thumbs/animal-from-the-sea.png": 3916,
	"./thumbs/animals-of-the-forest.png": 5097,
	"./thumbs/colouring-stickers.png": 33565,
	"./thumbs/dialogue-cards.png": 60951,
	"./thumbs/facial-expression.png": 10190,
	"./thumbs/flipover-illustrations.png": 66904,
	"./thumbs/massage-history.png": 19587,
	"./thumbs/massage-history2.png": 81530,
	"./title-small.svg": 10208,
	"./title.svg": 98407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;